import { Icon } from '@iconify/react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { useTextSelectionSearch } from '@context/TextSelectionSearchContext';
import { useExportTranscriptData } from '@hooks/postQueries';
import TagLibraryModal from './TagLibraryModal';
import TranscriptFilterByTag from './TranscriptFilterByTag';

const useStyles = makeStyles(() => ({
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const TranscriptListHeader = ({ selectedTags, onTagFilterChange }) => {
  const classes = useStyles();
  const [openTagLibraryModal, setOpenTagLibraryModal] = useState(false);
  const { mutate: exportTranscripts, isPending: isDownloading } = useExportTranscriptData();

  // Use the global search context instead of local state
  const { openSearchModal } = useTextSelectionSearch();

  const { id } = useParams();

  const handleDownloadAll = () => {
    exportTranscripts({ studyId: id });
  };

  return (
    <Box sx={{ py: 2, px: 1 }}>
      <Box className={classes.sectionHeader} sx={{ justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="subtitle2">Transcripts</Typography>

        <Box>
          <Tooltip title={'Search transcripts with advanced filters'} arrow>
            <IconButton
              size="small"
              sx={{
                border: '2px solid #e8e8e8',
                '&:hover': { border: '2px solid #303030' },
                mr: 1,
              }}
              onClick={openSearchModal}
            >
              <Icon
                icon="material-symbols:search"
                style={{ width: '20px', height: '20px', color: '#303030' }}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title={'Tag Library, Manage your all tags'} arrow>
            <IconButton
              LinkComponent={Link}
              size="small"
              sx={{
                border: '2px solid #e8e8e8',
                '&:hover': { border: '2px solid #303030' },
                mr: 1,
              }}
              onClick={() => setOpenTagLibraryModal(true)}
            >
              <Icon
                icon="majesticons:tag-line"
                style={{ width: '20px', height: '20px', color: '#303030' }}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title={'Download all transcripts'} arrow>
            <IconButton
              size="small"
              sx={{
                border: '2px solid #e8e8e8',
                '&:hover': { border: '2px solid #303030' },
                mr: 1,
              }}
              onClick={handleDownloadAll}
              disabled={isDownloading}
            >
              <Icon
                icon="material-symbols:download"
                style={{ width: '20px', height: '20px', color: '#303030' }}
              />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <TranscriptFilterByTag
        id={id}
        placeholder="Filter by tags"
        onFilterChange={onTagFilterChange}
        selectedFilters={selectedTags}
      />

      {openTagLibraryModal && (
        <TagLibraryModal
          open={openTagLibraryModal}
          onClose={() => setOpenTagLibraryModal(false)}
          studyId={id}
        />
      )}
    </Box>
  );
};

export default TranscriptListHeader;
